import React from 'react';
import styled from 'styled-components';

interface Props {
	onToggleInlineStyle: (style: string) => void;
	onToggleBlockType: (blockType: string) => void;
	onInsertLink: () => void;
	activeStyles: string[];
	activeBlockType: string;
}

const Toolbar = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	border-bottom: 1px solid #e2e8f0;
	padding: 8px 12px;
`;

const ToolbarBtn = styled.button<{$active: boolean}>`
	border: 0;
	border-radius: 4px;
	padding: 4px 8px;
	font: ${p => p.theme.ticketing.font.subheading2};
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.15s, color 0.15s;
	background: ${p => (p.$active ? '#e2e8f0' : 'transparent')};
	color: ${p => (p.$active ? '#0f172a' : '#475569')};
	&:hover {
		background: ${p => (p.$active ? '#e2e8f0' : '#f1f5f9')};
	}
`;

interface ToolbarButton {
	label: string;
	ariaLabel: string;
	action: () => void;
	isActive: boolean;
}

export function EditorToolbar({onToggleInlineStyle, onToggleBlockType, onInsertLink, activeStyles, activeBlockType}: Props) {
	const buttons: ToolbarButton[] = [
		{
			label: 'B',
			ariaLabel: 'Bold',
			action: () => onToggleInlineStyle('BOLD'),
			isActive: activeStyles.includes('BOLD'),
		},
		{
			label: 'I',
			ariaLabel: 'Italic',
			action: () => onToggleInlineStyle('ITALIC'),
			isActive: activeStyles.includes('ITALIC'),
		},
		{
			label: 'U',
			ariaLabel: 'Underline',
			action: () => onToggleInlineStyle('UNDERLINE'),
			isActive: activeStyles.includes('UNDERLINE'),
		},
		{
			label: '🔗',
			ariaLabel: 'Link',
			action: onInsertLink,
			isActive: false,
		},
		{
			label: '•',
			ariaLabel: 'Bullet list',
			action: () => onToggleBlockType('unordered-list-item'),
			isActive: activeBlockType === 'unordered-list-item',
		},
		{
			label: '1.',
			ariaLabel: 'Numbered list',
			action: () => onToggleBlockType('ordered-list-item'),
			isActive: activeBlockType === 'ordered-list-item',
		},
	];

	return (
		<Toolbar role="toolbar" aria-label="Formatting toolbar">
			{buttons.map(btn => (
				<ToolbarBtn
					key={btn.ariaLabel}
					type="button"
					aria-label={btn.ariaLabel}
					$active={btn.isActive}
					onMouseDown={e => {
						e.preventDefault();
						btn.action();
					}}
				>
					{btn.label}
				</ToolbarBtn>
			))}
		</Toolbar>
	);
}
